import { DISTINCT_PRODUCTS_CART_PREDICATE } from '~~/constants/regex';
import type { CartDiscountFieldsSource } from '~~/helpers/discounts/cartDiscountFields';

/**
 * How many *different* products the cart needs for the distinct products
 * discount. commercetools counts them into the cart's `numberOfDistinctProducts`
 * custom field and compares it in the cart predicate
 * (`custom.numberOfDistinctProducts >= 3`), so that is where the threshold comes
 * from. Unlike a volume discount, buying more pieces of the same product never
 * unlocks it.
 */
export const getDistinctProductsMinimalCount = (
  discount: Maybe<CartDiscountFieldsSource>,
): Maybe<number> => {

  const predicateMatch = discount?.cartPredicate?.match(DISTINCT_PRODUCTS_CART_PREDICATE)?.groups;

  if (!predicateMatch?.count) {

    return null;

  }

  const count = Number.parseInt(predicateMatch.count, 10);

  if (!count) {

    return null;

  }

  return predicateMatch.operator === '>' ? count + 1 : count;

};
